import { render, staticRenderFns } from "./TutorIndex.vue?vue&type=template&id=058667cf&scoped=true"
import script from "./TutorIndex.vue?vue&type=script&lang=js"
export * from "./TutorIndex.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "058667cf",
  null
  
)

export default component.exports